import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

// Icons
import Edit from '../../../assets/icons/edit.svg';
import Trash from '../../../assets/icons/trash.svg';
import { CreateDepartment, DeleteDepartment, SearchDepartment, UpdateDepartment } from '../../../utils/api';
import useToastNotification from '../../../hooks/useToastNotification';
import Loader from '../../loader/loader';

function Banner() {
    const [addFormValidated, setAddFormValidated] = useState(false);
    const [editFormValidated, setEditFormValidated] = useState(false);
    const { showError, showSuccess } = useToastNotification();

    const [visible, setVisible] = useState(false);
    const [editvisible, setEditVisible] = useState(false);
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const initialSelectedItemProperties = {
        title: '',
    };

    const [selectedItem, setSelectedItem] = useState({ ...initialSelectedItemProperties });

    const loadDepartments = async (page = pageIndex, size = pageSize) => {
        setLoading(true);
        try {
            let response = await SearchDepartment({
                title: '',
                pageIndex: page,
                pageSize: size,
            });
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
        } catch (error) {
            showError('خطا در بارگذاری اطلاعات');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadDepartments();
    }, [pageIndex, pageSize]);

    const openEditDialog = (rowData) => {
        setSelectedItem(rowData);
        setEditVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="d-flex justify-content-center gap-2" style={{ borderRight: '0.5px solid #D2D2D2' }}>
                <img
                    src={Edit}
                    alt="edit"
                    className="cursor-pointer mx-1"
                    onClick={() => openEditDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };

    const deleteItem = async (item) => {
        try {
            await DeleteDepartment({ id: item.id });
            showSuccess('عملیات با موفقیت انجام شد');
            setItems((old) => old.filter((filter) => item.id !== filter.id));
        } catch (error) {
            showError(error.response.data.message);
        }
    };

    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };

    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };

    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        // Trigger a data fetch for the new page
        loadDepartments(event.page, event.rows);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === true) {

            setLoading(true);
            await CreateDepartment({ title });
            setLoading(false);
            setVisible(false);
            document.body.style.overflow = 'auto';
            loadDepartments();
            showSuccess('عملیات با موفقیت انجام شد');
        } else {
            setAddFormValidated(true)
        }
    }
    const submitEdit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {

            setLoading(true);
            await UpdateDepartment(selectedItem);
            setLoading(false);
            setEditVisible(false);
            document.body.style.overflow = 'auto';
            loadDepartments();
            showSuccess('عملیات با موفقیت انجام شد');
        } else {
            setEditVisible(true)
        }
    }
    return (
        <>
            <div className="w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border">
                <h6 className="font-bold text-sm mb-0">دپارتمان ها</h6>
                <button className="btn btn-primary" onClick={() => {
                    setVisible(true)
                    document.body.style.overflow = 'hidden';
                }}>
                    تعریف دپارتمان
                </button>
            </div>
            <div>
                <DataTable
                    value={items}
                    size="small"
                    paginator
                    rows={pageSize}
                    totalRecords={totalRecords}
                    lazy
                    onPage={handlePagination}
                    first={(pageIndex - 1) * pageSize} // Current first record index
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    tableStyle={{ minWidth: '50rem' }}
                >
                    <Column field="id" header="ردیف" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="title" header="عنوان" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column header="عملیات" body={actionTemplate}></Column>
                </DataTable>
            </div>

            {/* Add Dialog */}
            <Dialog header="تعریف دپارتمان" visible={visible} onHide={() => {
                setVisible(false)
                document.body.style.overflow = 'auto';
            }} style={{ width: '40vw' }}>
                <Form noValidate validated={addFormValidated} className='mt-3' action='#' onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>عنوان</Form.Label>
                        <Form.Control type="text" required value={title} onChange={(e) => setTitle(e.target.value)} />
                        <Form.Control.Feedback type="invalid">
                            عنوان را وارد کنید
                        </Form.Control.Feedback>
                    </Form.Group>
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary w-100 mt-4"

                    >
                        تایید و ثبت {loading && <Loader />}
                    </button>
                </Form>
            </Dialog>

            {/* Edit Dialog */}
            <Dialog header="ویرایش دپارتمان" visible={editvisible} onHide={() => {
                setEditVisible(false)
                document.body.style.overflow = 'auto';
            }} style={{ width: '40vw' }}>
                <Form noValidate validated={editFormValidated} className='mt-3' onSubmit={submitEdit}>
                    <Form.Group>
                        <Form.Label>عنوان</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            value={selectedItem.title}
                            onChange={(e) => setSelectedItem({ ...selectedItem, title: e.target.value })}
                        />
                        <Form.Control.Feedback type="invalid">
                            عنوان را وارد کنید
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div className="d-flex gap-2 mt-4">
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary flex-1"
                           
                        >
                            تایید و ثبت {loading && <Loader />}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-primary flex-1"
                            onClick={() => {
                                setEditVisible(false)
                                document.body.style.overflow = 'auto';
                            }
                            }
                        >
                            انصراف
                        </button>
                    </div>
                </Form>
            </Dialog >
        </>
    );
}

export default Banner;
